import { render } from "./TorreGradientes.vue?vue&type=template&id=37bd08e0"
import script from "./TorreGradientes.vue?vue&type=script&lang=js"
export * from "./TorreGradientes.vue?vue&type=script&lang=js"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__